<template>
  <div class="interval-selector">
    <div class="field-group">
      <select v-model="unit" class="dropdown">
        <option value="Days">Day</option>
        <option value="Quarterly">Quarterly</option>
        <option value="Yearly">Yearly</option>
      </select>

      <div class="every-group" v-if="unit==='Days'">
        <span class="label">Every</span>
        <input
          type="number"
          min="1"
          v-model.number="interval"
          class="number-input"
        />
      </div>
    </div>

    <div class="hint">
      {{ hintText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntervalSelector',
  data () {
    return {
      unit: 'Days',
      interval: 1
    }
  },
  computed: {
    hintText () {
      if (this.unit === 'Days') {
        let returnText = ''
        if (this.interval === 1) {
          returnText = 'Everyday'
        } else {
          returnText = `Every ${this.interval} days`
        }
        return returnText
      }
      if (this.unit === 'week') {
        let returnText = ''
        if (this.interval === 1) {
          returnText = 'Every week'
        } else {
          returnText = `Every ${this.interval} weeks`
        }
        return returnText
      }
      if (this.unit === 'month') {
        let returnText = ''
        if (this.interval === 1) {
          returnText = 'Every month'
        } else {
          returnText = `Every ${this.interval} months`
        }
        return returnText
      }
      if (this.unit === 'Quarterly') {
        return 'Quarterly'
      }
      if (this.unit === 'Yearly') {
        return 'Yearly'
      }
      return ''
    }
  },
  watch: {
    unit () {
      this.emitChange()
    },
    interval () {
      this.emitChange()
    }
  },

  mounted () {
    // Emit initial value
    this.emitChange()
  },

  methods: {
    emitChange () {
      const tt = this.unit === 'Days' ? this.interval : null
      console.log(tt)
      this.$emit('change', {
        unit: this.unit,
        interval: this.unit === 'Days' ? this.interval : null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.interval-selector {
  width: 100%;

  .field-group {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .dropdown {
    flex: 1;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #dcdfe4;
    border-radius: 6px;
    font-size: var(--text-base);
    color: #1f2933;
    background-color: transparent;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg fill='none' stroke='%2399A3B2' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M6 9l6 6 6-6'/></svg>");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
  }

  .every-group {
    display: flex;
    align-items: center;
    gap: 8px;

    .label {
      font-size: var(--text-s);
      color: #6b7280;
      white-space: nowrap;
    }

    .number-input {
      width: 64px;
      height: 40px;
      padding: 0 10px;
      border: 1px solid #dcdfe4;
      border-radius: 6px;
      font-size: var(--text-base);
      color: #1f2933;
      outline: none;

      /* Remove arrows in Chrome */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Remove arrows in Firefox */
      &[type="number"] {
        -moz-appearance: textfield;
      }
    }
  }

  .hint {
    margin-top: 6px;
    font-size: var(--text-s);
    color: #6b7280;
  }
}
</style>
